import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta';
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import './styles/common.scss'
import moment from 'moment'
import Setting from './setting'

// 多语言
import i18n from './i18n';

Vue.config.productionTip = false
Vue.use(ViewUI)
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
// 金额
Vue.filter('amount', function (data) {
  if (typeof data !== 'number') { return data }
  return data.toFixed(0)
})
// 折后金额
Vue.filter('discount_amount', function (data) {
  if (typeof data !== 'number') { return data }
  // 四舍五入
  return data.toFixed(0)
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  metaInfo () {
    return {
      title: this.$store.state.metaInfo.title,
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.metaInfo.keywords
        },
        {
          name: 'description',
          content: this.$store.state.metaInfo.description
        },
        {
          vmid: 'ogTitle',
          property: 'og:title',
          content: this.$store.state.metaInfo.ogTitle
        },
        {
          vmid: 'ogDescription',
          property: 'og:description',
          content: this.$store.state.metaInfo.ogDescription
        },
        {
          vmid: 'ogImage',
          property: 'og:image',
          content: this.$store.state.metaInfo.ogImage
        }
      ]
    }
  },
  created () {
    Setting.titleSuffix = i18n.t('page.title');
    Setting.errorModalTitle = i18n.t('common.alert_title');
    // 初始化错误描述字符串
    const errors = i18n.t('error');
    for (const k in errors) {
      Setting.errorDescriptions[k] = errors[k];
    }
    // 初始化订单字符串
    for (const k in Setting.order_status) {
      Setting.order_status[k] = i18n.t('order.status.' + k);
    }
  }
}).$mount('#app')
